import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import AddEditForm from '../components/addEditForm.vue';

var EditSeaFreightBookingPage = function (_super) {
  __extends(EditSeaFreightBookingPage, _super);

  function EditSeaFreightBookingPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditSeaFreightBookingPage = __decorate([Component({
    components: {
      AddEditForm: AddEditForm
    }
  })], EditSeaFreightBookingPage);
  return EditSeaFreightBookingPage;
}(Vue);

export default EditSeaFreightBookingPage;